import React, { useState, useEffect } from 'react';

interface AuditLogProps {
  token: string;
}

const AuditLog: React.FC<AuditLogProps> = ({ token }) => {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/audit-log', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setLogs(await res.json());
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const actionBadge = (action: string) => {
    const colors: any = {
      login: { bg: '#dbeafe', color: '#1e40af' },
      register: { bg: '#d1fae5', color: '#065f46' },
      backup_created: { bg: '#fef3c7', color: '#92400e' },
      plan_changed: { bg: '#f3e8ff', color: '#6b21a8' },
    };
    const c = colors[action] || { bg: '#f1f5f9', color: '#475569' };
    return <span style={{ background: c.bg, color: c.color, padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{action.replace(/_/g, ' ')}</span>;
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Loading...</div>;

  return (
    <div style={{ background: 'white', borderRadius: '8px', padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ margin: 0 }}>Activity Log</h2>
        <button onClick={load} style={{ padding: '6px 12px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Refresh</button>
      </div>
      <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px' }}>Recent platform activity — last 200 events.</p>
      
      {logs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>No activity recorded yet.</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b', fontWeight: 600 }}>Time</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b', fontWeight: 600 }}>User</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b', fontWeight: 600 }}>Action</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b', fontWeight: 600 }}>Details</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', color: '#64748b', fontWeight: 600 }}>IP</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={log.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '8px 12px', color: '#64748b', whiteSpace: 'nowrap', fontSize: '12px' }}>{new Date(log.created_at).toLocaleString()}</td>
                  <td style={{ padding: '8px 12px', color: '#1e293b' }}>{log.email || 'System'}</td>
                  <td style={{ padding: '8px 12px' }}>{actionBadge(log.action)}</td>
                  <td style={{ padding: '8px 12px', color: '#64748b', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{log.details || '-'}</td>
                  <td style={{ padding: '8px 12px', color: '#94a3b8', fontSize: '12px', fontFamily: 'monospace' }}>{log.ip_address || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditLog;
